import { Component, OnInit, ViewChild } from '@angular/core';

import { DxDataGridComponent } from 'devextreme-angular';
import { SearchResult } from '../../property-search-service';
import { PropertySearchService } from '../../property-search-service';
import { Store } from '@ngrx/store';
import { CoreSearchDataState as AppState, getRegSearchState } from '../../../store/reducers/reducers';
import { Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { PropertySearchRowVM, GetProperySearchQuery, GetPropertySearchReportQuery, SearchFilter } from '../../../shared/viewmodels/ISearchService';
import { ReportViewerService } from '../../../shared/services/report-viewer.service';
import CustomStore from 'devextreme/data/custom_store';

@Component({
  selector: 'app-property-search-grid',
  providers: [PropertySearchService, ReportViewerService],
  templateUrl: './property-search-grid.component.html',
  styleUrls: ['./property-search-grid.component.css']
})
export class PropertySearchGridComponent implements OnInit {

  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
  public psresults: any = {};// PropertySearchRowVM[];
  applyFilterTypes: any;
  currentFilter: any;
  showFilterRow: boolean;
  focusedRowKey: number;
  recordCount: number;
  towns: string[] = [];
  doctypes: string[] = [];
  //doccategories: string[] = [];
  group: number;
  userInput: any;
  public errorMsg;

  public remoteOps: any = {};


  constructor(private service: PropertySearchService, private store: Store<AppState>, private router: Router, private reportService: ReportViewerService) {

    this.remoteOps = {
      paging: false,
      filtering: false,
      sorting: false,
      grouping: false,
      summary: false
    };

    this.store.select(getRegSearchState).pipe(take(1)).subscribe(data => {
      this.userInput = data;

      for (let city of this.userInput.city.citytowns[0].citytowns) {
        if (city.isChecked)
          this.towns.push(city.townAbbrev);
      }

      //Group Mapping to integer goes here
      console.log(`docCategories2[0]: ${JSON.stringify(this.userInput.docCategories2[0])}`);
      switch (this.userInput.docCategories2[0].docCategory) {
        case "allDocuments": {
          this.group = 0;
          break;
        }
        case "owner": {
          this.group = 1;
          break;
        }
        case "deeds": {
          this.group = 2;
          break;
        }
        case "discharges": {
          this.group = 3;
          break;
        }
        case "foreclosures": {
          this.group = 4;
          break;
        }
        case "homestead": {
          this.group = 5;
          break;
        }
        case "mortgages": {
          this.group = 6;
          break;
        }
        case "liensAndMortgages": {
          this.group = 7;
          break;
        }
        default:
          this.group = 0;
      }


      //for (let doctype of this.userInput.doct[0].doctypes) {
      //  if (doctype.isChecked)
      //    this.doctypes.push(doctype.docCode);
      //}

      //if (this.userInput.docCategoriesVS[0].mortgages) {
      //  this.doccategories.push("mortgages");
      //}

      //if (this.userInput.docCategoriesVS[0].conveyances) {
      //  this.doccategories.push("conveyances");
      //}


      //this.getPropertyResults();

    });

    this.showFilterRow = true;
    this.applyFilterTypes = [{
      key: "auto",
      name: "Immediately"
    }, {
      key: "onClick",
      name: "On Button Click"
    }];

    this.currentFilter = this.applyFilterTypes[0].key;

  }

  ngOnInit() {
    this.psresults = new CustomStore({
      key: "docID",
      load: (loadOption: any) => {
        let query = new GetProperySearchQuery({
          lastName: this.userInput.name[0].lastcorpName,
          firstName: this.userInput.name[0].fName,
          fromDate: this.userInput.date[0].fromDate,
          toDate: this.userInput.date[0].toDate,
          towns: this.towns,
          group: this.group
        });

        return this.service.getPropertySearchResults(query).toPromise().then(data => {
          this.recordCount = data.propertySearchRows.length;
          return {
            data: data.propertySearchRows,
            totalCount: data.propertySearchRows.length
          };

        }).catch(error => { throw 'Data Loading Error' });
      }
    });
  }

  getPropertyResults() {

    let query = new GetProperySearchQuery({
      lastName: this.userInput.name[0].lastcorpName,
      firstName: this.userInput.name[0].fName,
      fromDate: this.userInput.date[0].fromDate,
      toDate: this.userInput.date[0].toDate,
      towns: this.towns,
      group: this.group
    });

    console.log(`prop search query: ${JSON.stringify(query)}`);
    this.service.getPropertySearchResults(query).subscribe(
      data => {
        console.log(`prop search results:${JSON.stringify(data.propertySearchRows)}`);
        this.psresults = data.propertySearchRows;
        this.recordCount = this.psresults.length;
      }
    );
  }

  clearFilter() {
    this.dataGrid.instance.clearFilter();
  }

  onInitialized(e) {

  }
  imgClicked(event) {
    if (!this.dataGrid.instance.isRowSelected(event.row.key)) {
      this.dataGrid.instance.selectRows(event.row.key, false);
    }
    // this.nav.visible = false;


  }

  onExpanding(e) {
    this.focusedRowKey = e.component.option("focusedRowIndex");
    this.focusedRowKey = e.key.index;
    e.component.collapseAll(-1);
  }

  assignTypes(filters: SearchFilter[]) {
    if (filters) {
      filters.forEach(fl => {
        if (fl.filterType == 'join') {
          this.assignTypes(fl.filters);
        } else {
          for (var prop in this.psresults[0]) {
            if (prop == fl.fieldName) {
              fl.fieldType = typeof this.psresults[0][prop];
            }
          }
        }

      });
    }
  }


  export() {

    var filtersUsed = this.dataGrid.instance.getCombinedFilter(true);// [["firstGrantor", "contains", "bed"], "and", ["firstGrantee", "contains", "or"], "and", ["recLandBook", "contains", "3"]];//[[["recordDate", "<", "2000-04-03T04:00:00.000Z"], "or", ["recordDate", ">=", "2000-04-04T04:00:00.000Z"]], "and", ["firstGrantor", "contains", "BED"]];//
    var filters = new Array<string>();
    var filterExpression = filtersUsed ? JSON.stringify(filtersUsed) : "";
    console.log(`filterExpression: ${filterExpression}`);
    var filterObjs = new Array<SearchFilter>();
    if (filterExpression) {
      var filtersOnGrid = SearchFilter.subHelper(filtersUsed, 0);
      filterObjs = [...filtersOnGrid];
      this.assignTypes(filterObjs);
      console.log(`filterObjs: ${JSON.stringify(filterObjs)}`);
      //filtersOnGrid.forEach(f => filters.push(JSON.stringify(f)));
      //console.log(`filters: ${JSON.stringify(filters)}`);
    }



    let query = new GetPropertySearchReportQuery({
      lastName: this.userInput.name[0].lastcorpName,
      firstName: this.userInput.name[0].fName,
      fromDate: this.userInput.date[0].fromDate,
      toDate: this.userInput.date[0].toDate,
      towns: this.towns,
      group: this.group,
      sortBy: new Array<string>(),
      sortDirection: "desc",
      filterExpression: filterExpression,
      filterObjects: filterObjs
    });

    this.reportService.getPropertySearchReport(query).subscribe((reportName) => {
      //this.reportUrl = reportName.reportName;
      console.log(`rerportName: ${reportName.reportName}`);
      this.router.navigate([`/report-viewer/${reportName.reportName}`]);

    });


  }
}
